import { apiService } from '../../..'
import {
  GetPreferredPaymentDayResponse,
  CreatePaymentScheduleExampleResponse,
  PreferredPaymentDayQuery,
  UpdatePreferredPaymentDayResponse,
  UpdatePreferredPaymentDayQuery,
} from '../types'

const BASE_URL = '/portal/consumers/preferred-payment-day'

export const preferredPaymentDayService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getPreferredPaymentDay: build.query<GetPreferredPaymentDayResponse, void>({
      query: () => {
        return {
          url: BASE_URL,
          method: 'get',
        }
      },
      providesTags: ['Payday'],
    }),
    createPaymentScheduleExample: build.mutation<CreatePaymentScheduleExampleResponse, PreferredPaymentDayQuery>({
      query: ({ preferredPaymentDay }) => {
        return {
          url: `${BASE_URL}/payment-schedule-example`,
          method: 'POST',
          data: { preferredPaymentDay: preferredPaymentDay.toUpperCase() },
        }
      },
    }),
    confirmPreferredPayday: build.mutation<void, PreferredPaymentDayQuery>({
      query: ({ preferredPaymentDay }) => {
        return {
          url: BASE_URL,
          method: 'POST',
          data: { preferredPaymentDay: preferredPaymentDay.toUpperCase() },
        }
      },
      invalidatesTags: ['Payday'],
    }),
    deletePreferredPayday: build.mutation<void, null>({
      query: () => {
        return {
          url: BASE_URL,
          method: 'POST',
          data: { preferredPaymentDay: null },
        }
      },
      invalidatesTags: ['Payday'],
    }),
    updatePreferredPayday: build.mutation<UpdatePreferredPaymentDayResponse, UpdatePreferredPaymentDayQuery>({
      query: ({ preferredPaymentDay, profilingSessionId, token }) => {
        return {
          url: `/portal/consumers/checkout/${token}/preferred-payment-day`,
          method: 'POST',
          data: {
            preferredPaymentDay,
            profilingSessionId,
          },
        }
      },
      invalidatesTags: ['Payday'],
    }),
  }),
})
